import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import "./style.css";
import { t } from 'i18next';
import i18n from 'src/i18n';
import {
  createFunctionApi,
  updateFunctionApi,
  fetchDataApi,
  deleteFunctionApi
} from "../../services/functionServices";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import LoadingScreen from "../../Loading/LoadingScreen";

import { useTranslation } from 'react-i18next'

// ✅ نوع البيانات الصحيح
interface IFunction {
  id: string;
  name: string;
  description?: string;
}

// ✅ نفس البنية المطلوبة للإنشاء والتحديث
type FunctionFormData = {
  name: string;
  description?: string;
};

const CreateFunctionPage: React.FC = () => {
      const { t } = useTranslation()
    
  const {
    register: createForm,
    handleSubmit: handleCreateSubmit,
    reset: resetCreate,
    formState: { errors: createErrors }
  } = useForm<FunctionFormData>();

  const {
    register: updateForm,
    handleSubmit: handleUpdateSubmit,
    reset: resetUpdate,
    setValue: setUpdateValue,
    formState: { errors: updateErrors }
  } = useForm<FunctionFormData>();

  const [functions, setFunctions] = useState<IFunction[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalMode, setModalMode] = useState<"create" | "update">("create");
  const [selectedFunction, setSelectedFunction] = useState<IFunction>({ id: "", name: "", description: "" });
    const [query, setQuery] = useState<string>("");
    const [perPage, setPerPage] = useState<number>(10);
    const [pageNo, setpageNo] = useState<number>(0);
    const [total, setTotal] = useState<number>(0);
    const [totalRecorders, setTotalRecorder] = useState<number>(0);
     const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");
  const fetchData = async () => {
        
        try {
            const data = await fetchDataApi(`functions?query=${query}&perPage=${perPage}&pageNo=${pageNo}`);
            ////console.log(data);
            setFunctions(data.data); // Assuming the response data contains functions

            setTotal(Math.ceil(data.totalCount / perPage)); // Assuming the response data contains totalCount
            setTotalRecorder(Math.ceil(data.totalCount));
            setLoading(false);
            setError(false);
        } catch (error: any) {
            ////console.log("Error fetching data:", error);

            if (error.message.includes("Forbidden")) {
                toast.error("You do not have permission to perform this action.");
            } else {
                toast.error("Failed to fetch function");
            }

            setLoading(false);
            setError(true);
            setErrorMsg(error.message);
        }
    };


    useEffect(() => {
      
            fetchData();
   
    }, [query, perPage, pageNo]);
    

  const onCreate = async (data: FunctionFormData) => {
    try {
      await createFunctionApi(data);
      toast.success("Function created successfully");
      fetchData();
      resetCreate();
      setModalOpen(false);
    } catch {
      toast.error("Failed to create function");
    }
  };

  const onUpdate = async (data: FunctionFormData) => {
    try {
      await updateFunctionApi(selectedFunction.id, data);
      toast.success("Function updated successfully");
      fetchData();
      resetUpdate();
      setModalOpen(false);
    } catch {
      toast.error("Failed to update function");
    }
  };

  const openCreateModal = () => {
    setModalMode("create");
    resetCreate();
    setModalOpen(true);
  };

  const openUpdateModal = (fn: IFunction) => {
    setModalMode("update");
    setSelectedFunction(fn);
    setUpdateValue("name", fn.name);
    setUpdateValue("description", fn.description || "");
    setModalOpen(true);
  };


  ;



  const openDeleteModal = (fn: IFunction) => {
    setSelectedFunction(fn);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteFunctionApi(selectedFunction.id);
      toast.success("Function deleted successfully");
      fetchData();
      setShowDeleteModal(false);
    } catch {
      toast.error("Failed to delete function");
    }
  };
  if (loading) return <LoadingScreen />;

  return (
     <div className="root">
    <div className="">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-lg px-2">{t("function.Functions")}</h5>
            <button
               onClick={openCreateModal}
                 className=" btn-create text-white ">
                 <FaPlus className="me-1" /> {t("function.Create Function")}
              </button>
      
      </div>

      <table className="styled-table">
        <thead className="">
          <tr>
            <th>{t("function.Name")}</th>
            <th>{t("function.Description")}</th>
            <th>{t("function.Actions")}</th>
          </tr>
        </thead>
        <tbody>
          {functions.map((fn) => (
            <tr key={fn.id}>
              <td>{fn.name}</td>
              <td>{fn.description}</td>
              <td>
            <div className="d-flex  align-items-center mb-3">
                    <button  className="action-button" onClick={() => openUpdateModal(fn)}>
                  <FaEdit className="me-1" size={16} /> 
                </button>

                 <button className="action-button-without-border"
                  color="danger"
                  
                  onClick={() => openDeleteModal(fn)}
                >
                  <FaTrash />
                </button>
            </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          {modalMode === "create" ? "Create Function" : "Update Function"}
        </ModalHeader>
        <form onSubmit={modalMode === "create" ? handleCreateSubmit(onCreate) : handleUpdateSubmit(onUpdate)}>
          <ModalBody>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Name</label>
              <input
                type="text"
                id="name"
                className="form-control"
                {...(modalMode === "create"
                  ? createForm("name", { required: "Name is required" })
                  : updateForm("name", { required: "Name is required" }))}
              />
              <div className="text-danger small">
                {modalMode === "create" && createErrors.name?.message}
                {modalMode === "update" && updateErrors.name?.message}
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="description" className="form-label">Description</label>
              <textarea
                id="description"
                className="form-control"
                {...(modalMode === "create"
                  ? createForm("description")
                  : updateForm("description"))}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="submit" color="primary" className="submit-button4">
              {modalMode === "create" ? "Create" : "Update"}
            </Button>
            <Button type="button" color="secondary" onClick={() => setModalOpen(false)}> {t("function.Cancel")}</Button>
          </ModalFooter>
        </form>
      </Modal>


       {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)}>
        <ModalHeader toggle={() => setShowDeleteModal(false)}>
          {t("function.Confirm Delete")}
        </ModalHeader>
        <ModalBody>
          {t("function.Are you sure you want to delete this function?")}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            {t("function.Delete")}
          </Button>
          <Button color="secondary" onClick={() => setShowDeleteModal(false)}>
            {t("function.Cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
    </div>
  );
};

export default CreateFunctionPage;
